// extracted by mini-css-extract-plugin
module.exports = {"currency":"CurrencySelect_currency__2aZjI","icon":"CurrencySelect_icon__lbR50"};